import chroma from 'chroma-js';

import {
  tooltipOptions,
  GreyColors,
  getBins,
} from '../../../shared/chart-options';
import { HistogramTooltip } from '../PossessionsFilter/HistogramTooltip';
import { round2 } from '../../../lib/format';

export function getHistogramChartOptions(config, data) {
  const dataSeries = data.map(combination => combination[config.property]);
  const seriesData = getBarSeriesData(dataSeries);

  const colorFormatter = getBarColorFormatter(dataSeries, config.colors);

  return getHistogramEChartOptions(config.name, seriesData, colorFormatter);
}

function getHistogramEChartOptions(name, data, colorFormatter) {
  return {
    grid: {
      top: 0,
      bottom: 20,
      left: 10,
      right: 10,
    },
    name,
    color: colorFormatter,
    tooltip: {
      ...tooltipOptions,
      formatter: HistogramTooltip,
    },
    xAxis: {
      type: 'category',
      axisLine: GreyColors.axisLine,
    },
    yAxis: {
      type: 'value',
      show: false,
      axisTick: { lineStyle: GreyColors.lineStyle },
      splitLine: { lineStyle: GreyColors.splitLine },
    },
    series: [
      {
        data,
        name,
        type: 'bar',
      },
    ],
  };
}

function getBarSeriesData(data) {
  if (!data || !data.length) return [[]];

  return getBins(data).map(bin => [round2(bin.x0), bin.length]);
}

function getBarColorFormatter(seriesData, colors) {
  const bins = getBins(seriesData);

  return ({ dataIndex }) => chroma.scale(colors).colors(bins.length)[dataIndex];
}
